import Notification from 'flarum/components/Notification';
import { truncate } from 'flarum/utils/string';

export default class PostAdvcommentedNotification extends Notification {
  icon() {
    return 'fas fa-reply';
  }

  href() {
    const notification = this.attrs.notification;
    const post = notification.subject();
    const content = notification.content();

    return app.route.discussion(post.discussion(), content && content.replyNumber);
  }

  content() {
    const notification = this.attrs.notification;
    const user = notification.fromUser();
    let res;
    try {
      res = app.translator.trans('tolyod-advdiscus.forum.notifications.post_mentioned_text', {user});
    } catch(e) {
      res = 'oops'
      console.log(e);
    }

    return res;
  }

  excerpt() {
    return truncate(this.attrs.notification.subject().contentPlain(), 200);
  }
}
